<template>
  <div class="proprietorPrivateletterList">
    <el-card>
      <div class="location">
        <el-button type="primary" class="btn-center" @click="openToUser" v-if="gardenId != 0" :disabled="isUser">{{$t('lang.btn_sendToUser')}}</el-button>
      </div>
      <div class="location">
        <el-button type="primary" class="btn-center" @click="openToBuilding" v-if="gardenId != 0" :disabled="isBuilding">{{$t('lang.btn_sendToBuilding')}}</el-button>
      </div>
      <!-- 给业主发私信 -->
      <div v-show="show === 1">
        <el-form ref="userForm" :rules="rules" :model="userForm" class="form-width" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
          <el-form-item :label="$t('lang.lab_titleAnd')" prop="title" >
            <el-input v-model="userForm.title" :placeholder="$t('lang.lab_pleaseEnterTitle')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_userTel')" prop="value" >
            <el-input v-model="userForm.value" :placeholder="$t('lang.lab_pleaseEnterTel')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_contentAnd')" prop="content">
            <quill-editor v-model="userForm.content" ref="myQuillEditor1" :options="editorOption" @change="onEditorChange($event)"></quill-editor>
            <span class="editorText" v-show="isLength < 10001">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
            <span class="editorTextTips" v-show="isLength >= 10001">{{$t('lang.lab_editor_tips')}}</span>
          </el-form-item>
        </el-form>
        <el-button class="btn-first" @click="cancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button class="detailbtn" @click="resetForm('userForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary"  @click="sendToUser('userForm')">{{$t('lang.btn_send')}}</el-button>
      </div>
      <!-- 给一栋楼用户发私信 -->
      <div v-show="show === 2">
        <el-form ref="buildingForm" :rules="rules" :model="buildingForm"  class="form-width" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
          <el-form-item :label="$t('lang.lab_titleAnd')" prop="title" >
            <el-input v-model="buildingForm.title" :placeholder="$t('lang.lab_pleaseEnterTitle')"></el-input>
          </el-form-item>
        <el-form-item :label="$t('lang.lab_buildNum')" prop="value" >
          <el-select v-model="buildingForm.value" :placeholder="$t('lang.lab_selectHouse')">
            <el-option
              v-for="(item, index) in houses"
              :key="index"
              :value="index"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
          <el-form-item :label="$t('lang.lab_contentAnd')" prop="content">
            <quill-editor v-model="buildingForm.content" ref="myQuillEditor2" :options="editorOption" @change="onEditorChange($event)"></quill-editor>
            <span class="editorText" v-show="isLength < 10001">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
            <span class="editorTextTips" v-show="isLength >= 10001">{{$t('lang.lab_editor_tips')}}</span>
          </el-form-item>
        </el-form>
        <el-button class="btn-first" @click="cancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button class="detailbtn" @click="resetForm('buildingForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary"  @click="sendToBuilding('buildingForm')">{{$t('lang.btn_send')}}</el-button>
      </div>
      <div class="location">
        <el-button type="primary" class="btn-center" @click="openToAll" v-if="gardenId == 0">{{$t('lang.btn_sendToAll')}}</el-button>
      </div>
      <!-- 给全部用户发私信 -->
      <div v-show="show === 3">
        <el-form ref="allForm" :rules="rules" :model="allForm" class="form-width" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
          <el-form-item :label="$t('lang.lab_titleAnd')" prop="title" >
            <el-input v-model="allForm.title" :placeholder="$t('lang.lab_pleaseEnterTitle')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_contentAnd')" prop="content">
            <quill-editor v-model="allForm.content" ref="myQuillEditor3" :options="editorOption" @change="onEditorChange($event)"></quill-editor>
            <span class="editorText" v-show="isLength < 10001">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
            <span class="editorTextTips" v-show="isLength >= 10001">{{$t('lang.lab_editor_tips')}}</span>
          </el-form-item>
        </el-form>
        <el-button class="btn-first" @click="cancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button class="detailbtn" @click="resetForm('allForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary"  @click="sendToAll('allForm')">{{$t('lang.btn_send')}}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:proprietorPrivateletterList
 *@Description:业主私信
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-02-19
 */
// 引入富文本功能键tooltip效果
import { addQuillTitle } from '../../../config/quill-title.js'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      show: 0, // 输入区域开关：0.close 1.user 2.building 3.all
      isLength: 0, // 富文本字数长度
      houses: [], //  存储根据小区请求回来的楼号
      isUser: false,
      isBuilding: false,
      userForm: {
        title: '',
        content: '',
        type: '',
        value: '',
      }, // 业主
      buildingForm: {
        title: '',
        content: '',
        type: '',
        value: '',
      }, // 一栋楼
      allForm: {
        title: '',
        content: ''
      }, // 所有
      rules: {
        title: [{ required: true, message: this.$i18n.t('lang.lab_pleaseEnterTitle'), trigger: 'blur' }],
        content: [{ required: true, message: this.$i18n.t('lang.lab_pleaseEnterContent'), trgger: 'blur' }],
        value: [{ required: true, message: this.$i18n.t('lang.lab_pleaseInput'), trigger: 'change' }],
      },
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
            ['blockquote', 'code-block'], // 引用，代码块
            [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
            [{ list: 'ordered' }, { list: 'bullet' }], // 列表
            [{ script: 'sub' }, { script: 'super' }], // 上下标
            [{ indent: '-1' }, { indent: '+1' }], // 缩进
            [{ direction: 'rtl' }], // 文本方向
            [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
            [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
            [{ font: [] }], // 字体
            [{ align: [] }], // 对齐方式
            ['clean'], // 清除字体样式
            ['image', 'video'] // 上传图片、上传视频
          ]
        },
        theme: 'snow',
        placeholder: this.$i18n.t('lang.lab_text'),
      },
    }
  },
  created() {
    this.selectHouse()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.cancel()
    }
  },
  methods: {
    // 根据小区选择获取楼号
    selectHouse() {
      let loading = this.$loading()
      this.$get(`/gardenGrids/?type=1&parentId=${this.gardenId}&pageNo=1&pageSize=9999`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.houses = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // user按钮
    openToUser() {
      this.handleClosed()
      this.isBuilding = false
      this.isUser = true
      this.show = 1
      addQuillTitle()
    },
    // building按钮
    openToBuilding() {
      this.handleClosed()
      this.isBuilding = true
      this.isUser = false
      this.show = 2
      addQuillTitle()
    },
    // all按钮
    openToAll() {
      this.handleClosed()
      this.show = 3
      addQuillTitle()
    },
    // user发送
    sendToUser(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            title: this.userForm.title,
            content: this.userForm.content,
            type: 1,
            value: this.userForm.value,
            gardenid: this.gardenId,
          }
          let loading = this.$loading()
          this.$post('/letters', params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.cancel()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // building发送
    sendToBuilding(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            title: this.buildingForm.title,
            content: this.buildingForm.content,
            type: 2,
            value: this.buildingForm.value,
            gardenid: this.gardenId,
          }
          let loading = this.$loading()
          this.$post('/letters', params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.cancel()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // all发送
    sendToAll(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            title: this.allForm.title,
            content: this.allForm.content,
          }
          let loading = this.$loading()
          this.$post('/allLetters', params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.cancel()
              }
              setTimeout(() => {
                loading.close()
              }, 200)
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 取消
    cancel() {
      this.handleClosed()
      this.isBuilding = false
      this.isUser = false
      this.show = 0
    },
    // 清空
    resetForm(formName) {
      this.handleClosed()
      setTimeout(() => {
        this.$refs[formName].clearValidate()
      }, 0)
    },
    // 监听关闭
    handleClosed() {
      if (this.show === 1) {
        this.userForm.title = ''
        this.userForm.content = ''
        this.userForm.type = ''
        this.userForm.value = ''
        this.$refs.userForm.clearValidate()
      } else if (this.show === 2) {
        this.buildingForm.title = ''
        this.buildingForm.content = ''
        this.buildingForm.type = ''
        this.buildingForm.value = ''
        this.$refs.buildingForm.clearValidate()
      } else if (this.show === 3) {
        this.allForm.title = ''
        this.allForm.content = ''
        this.$refs.allForm.clearValidate()
      }
    },
    // 内容字数提示
    onEditorChange(event) {
      event.quill.deleteText(10000, 4)
      this.isLength = event.quill.getLength() - 1
      this.manualValidate()
    },
    // 富文本验证
    manualValidate() {
      if (this.show === 1) {
        this.$refs.userForm.validateField('content')
      } else if (this.show === 2) {
        this.$refs.buildingForm.validateField('content')
      } else if (this.show === 3) {
        this.$refs.allForm.validateField('content')
      }
    }
  },
  // 调用富文本方法生效
  mounted() {
    addQuillTitle()
  }
}
</script>

<style lang="scss">
.proprietorPrivateletterList{
  .btn-center{
    width: 200px;
    margin-bottom: 35px;
    margin-top: 20px;
  }
  .location{
    text-align:center;
  }
  .form-width{
    width: 80%;
  }
}
</style>